import { render, staticRenderFns } from "./ServicesCategoriesNewHeader.vue?vue&type=template&id=7ac16300&"
import script from "./ServicesCategoriesNewHeader.vue?vue&type=script&lang=js&"
export * from "./ServicesCategoriesNewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports